<template>
  <div class="contact">
        <Header></Header>
        <nav class="banner">
					<div class="page-container">
						<div class="left-sidebar" ref="leftSidebar" :class="{ 'follow-scroll': isFollowing }">
							<!-- <div class="contentLeft_row"> -->
								<div class="contactText">Contact Us</div>
								<div class="title">
									<div>Unlock The Best</div>
									<div>Payment Experiences</div>
									<div>with PandaPay Right Now</div>
									<!-- <div></div> -->
								</div>
								<div class="title1">
									<div class="title1_row">
										<div><img src="../../assets/hookLogo.png"/></div>
										<div class="title1_text">Zero cost integration, only 3 steps are needed to start.</div>
									</div>
									<div class="title1_row">
										<div><img src="../../assets/hookLogo.png"/></div>
										<div class="title1_text">Support different payment methods worldwide and unlock </br>local payment experiences worldwide.</div>
									</div>
									<div class="title1_row">
										<div><img src="../../assets/hookLogo.png"/></div>
										<div class="title1_text">Unparalleled payment capabilities accelerate your global </br>business growth.</div>
									</div>
									<div class="title1_row">
										<div><img src="../../assets/hookLogo.png"/></div>
										<div class="title1_text">7 * 24-hour service team, fully ensuring the stable operation of </br>your business.</div>
									</div>
									<div class="title1_row" style="margin-top: 16px;margin-bottom: 18px;">
										<div class="title1_text">If any questions or needs, you can also reach us directly via email.</div>
										
									</div>
									<div class="title1_email">
										<div><img src="../../assets/contactLogo.png"/></div>
										<div>bd@hkpandapay.com</div>
									</div>
							</div>
							<!-- </div> -->
						</div>
						<div class="contentRight">
							<div class="form">
								<div class="form_text">
									Simply tap a few times, and we’ll get back to you as soon as possible
								</div>
							    <Form ref="form" :model="form" label-position="top" :rules="ruleInline">
							        <FormItem class="form_tiem" prop="firstName" label="Your name*">
							            <Input class="input mr_30" :maxlength="200" v-model="form.firstName" placeholder="Please enter your name"></Input>
							        </FormItem>
											<FormItem class="form_tiem" prop="companyName" label="Company name*">
											    <Input class="input mr_30" :maxlength="200" v-model="form.companyName" placeholder="Please enter Company name"></Input>
											</FormItem>
							        <FormItem  class="form_tiem" prop="email"label="Contact email*">
							            <Input class="input" :maxlength="200" v-model="form.email" placeholder="you@example.com" ></Input>
							        </FormItem>
							        <FormItem class="mt_32 form_tiem" prop="phone" label="Mobile phone*">
												<div class="select_input">
													<Input class="input mr_30" :maxlength="200" v-model="form.phone" placeholder="Phone number">
														<Select v-model="form.areaCode" slot="prepend" class="numberSelect" placeholder="" >
														            <Option v-for="item in phoneList"  :value="item.phoneNumber" :key="item.index" :label="'+'+item.phoneNumber">
																				<div style="display: flex;">
																					<div>+{{item.phoneNumber}}</div>
																					<!-- <Tooltip theme="light" :content="item.phoneNumber" max-width="110"> -->
																					<el-tooltip class="itemTooltip" effect="light" :content="item.countryName" placement="top-start" :disabled="item.phoneNumber.length+item.countryName.length>12?false:true">
																					<div class="inCompanyName" style="overflow: hidden !important;text-overflow: ellipsis !important;white-space: nowrap !important;margin-left: 10px;color: #0f0f1066;font-size: 14px;">{{item.countryName}}</div>
																					<!-- </Tooltip> -->
																					</el-tooltip>
																					<div class="outCompanyName" style="overflow: hidden !important;text-overflow: ellipsis !important;white-space: nowrap !important;margin-left: 10px;color: #0f0f1066;font-size: 14px;">{{item.countryName}}</div>
																				</div>	
																					<!-- <span style="margin-left: 10px;color: #0f0f1066;font-size: 14px;">{{item.countryName}}</span> -->
																					</Option>
														</Select>
													</Input>
												</div>
							        </FormItem>
											<FormItem  class="form_tiem" prop="country"label="Country*">
											    <Input class="input" :maxlength="200" v-model="form.country" placeholder="Please enter your Country" ></Input>
											</FormItem>
											<FormItem class="mt_32 form_tiem" prop="jobTitle" label="Job title*">
											    <Input class="input" :maxlength="200" v-model="form.jobTitle" placeholder="Please enter Job title"></Input>
											</FormItem>
							        <FormItem class="mt_32 form_tiem" prop="employees" label="Employees*" >
												<div class="selectRow">
													<Select v-model="form.employees" placeholder="Please enter Employees" >
													            <Option v-for="item in employeesList"  :value="item.personsSize" :key="item.index">{{item.personsSize}}</Option>
													</Select>
												</div>
							        </FormItem>
											<FormItem class="mt_32 form_tiem" prop="industry" label="Industry*" >
												<div class="selectRow">
													<Select v-model="form.industry" placeholder="Please enter Industry" >
													            <Option v-for="item in industryList"  :value="item.industryName" :key="item.index">{{item.industryName}}</Option>
													</Select>
												</div>
											</FormItem>
											<FormItem  class="form_tiem" prop="webLink"label="Web link&Product link">
											    <Input class="input" :maxlength="200" v-model="form.webLink" placeholder="" ></Input>
											</FormItem>
							        <FormItem class="mt_32" prop="message" label="Message*">
												<div class="textarea">
													<Input type="textarea" :maxlength="200" placeholder="Please tell us about your needs. 
To better understand your needs and provide improved service." v-model="form.message"></Input>
												</div>
							            
							        </FormItem>
							        <FormItem label="">
							            <span class="infoText">
							
							            By submitting this form you agree to our terms and conditions and our Privacy Policy which explains how we may collect, use and disclose your personal information including to third parties.
							            
							            </span>
							        </FormItem>
							        <FormItem label="">
												<div class="btnRow">
													<Button type="primary" class="submitBtn" @click="submit('form')" :loading="loading">Contact sales</Button>
												</div>
							            
							        </FormItem>
							    </Form>
							</div>
						</div>
					</div>
					
            
        </nav>
        <Footer></Footer>
  </div>
</template>

<script>
import apiUrl from '../../services/api/user.service'
import Header from '../../components/header'
import Footer from '../../components/footer'
import {Notice} from 'iview'
export default {
  name: '',
  data () {
    return {
			loading:false,
        form:{
            firstName:'',
            companyName:'',
            country:'',
            email:'',
            areaCode:'86',
            phone:'',
            jobTitle:'',
            employees:'',
            industry:'',
            webLink:'',
            message:'',
        },
				employeesList:[
					{
						personsSize:'1-15 persons',
					},
					{
						personsSize:'15-50 persons',
					},
					{
						personsSize:'50-150 persons',
					},
					{
						personsSize:'150-500 persons',
					},
					{
						personsSize:'500-2000 persons',
					},
					{
						personsSize:'Above 2000 persons',
					},
					],
					industryList:[
					{
						industryName:'E-commerce',
					},
					{
						industryName:'MEDIA',
					},
					{
						industryName:'NBFC',
					},
					{
						industryName:'Other',
					},
					{
						industryName:'Software Services',
					},
					{
						industryName:'GAME',
					},
					{
						industryName:'Live Dating',
					},
					],
				phoneList:[
					{"phoneNumber":"213","countryName":"ALGERIA","countryNameZh":"阿尔及利亚"},
					    {"phoneNumber":"376","countryName":"ANDORRA","countryNameZh":"安道尔"},
					    {"phoneNumber":"1264","countryName":"ANGUILLA","countryNameZh":"安圭拉"},
					    {"phoneNumber":"1268","countryName":"ANTIGUA AND BARBUDA","countryNameZh":"安提瓜和巴布达"},
					    {"phoneNumber":"54","countryName":"ARGENTINA","countryNameZh":"阿根廷"},
					    {"phoneNumber":"374","countryName":"ARMENIA","countryNameZh":"亚美尼亚"},
					    {"phoneNumber":"61","countryName":"AUSTRALIA","countryNameZh":"澳大利亚"},
					    {"phoneNumber":"43","countryName":"AUSTRIA","countryNameZh":"奥地利"},
					    {"phoneNumber":"994","countryName":"AZERBAIJAN","countryNameZh":"阿塞拜疆"},
					    {"phoneNumber":"973","countryName":"BAHRAIN","countryNameZh":"巴林"},
					    {"phoneNumber":"880","countryName":"BANGLADESH","countryNameZh":"孟加拉国"},
					    {"phoneNumber":"32","countryName":"BELGIUM","countryNameZh":"比利时"},
					    {"phoneNumber":"501","countryName":"BELIZE","countryNameZh":"伯利兹"},
					    {"phoneNumber":"229","countryName":"BENIN","countryNameZh":"贝宁"},
					    {"phoneNumber":"1441","countryName":"BERMUDA","countryNameZh":"百慕大群岛"},
					    {"phoneNumber":"591","countryName":"BOLIVIA, PLURINATIONAL STATE OF","countryNameZh":"玻利维亚多民族国"},
					    {"phoneNumber":"55","countryName":"BRAZIL","countryNameZh":"巴西"},
					    {"phoneNumber":"673","countryName":"BRUNEI DARUSSALAM","countryNameZh":"文莱达鲁萨兰国"},
					    {"phoneNumber":"359","countryName":"BULGARIA","countryNameZh":"保加利亚"},
					    {"phoneNumber":"226","countryName":"BURKINA FASO","countryNameZh":"布基纳法索"},
					    {"phoneNumber":"855","countryName":"CAMBODIA","countryNameZh":"柬埔寨"},
					    {"phoneNumber":"237","countryName":"CAMEROON","countryNameZh":"喀麦隆"},
					    {"phoneNumber":"235","countryName":"CHAD","countryNameZh":"乍得"},
					    {"phoneNumber":"56","countryName":"CHILE","countryNameZh":"智利"},
					    {"phoneNumber":"86","countryName":"CHINA","countryNameZh":"中国"},
					    {"phoneNumber":"57","countryName":"COLOMBIA","countryNameZh":"哥伦比亚"},
					    {"phoneNumber":"682","countryName":"COOK ISLANDS","countryNameZh":"库克群岛"},
					    {"phoneNumber":"506","countryName":"COSTA RICA","countryNameZh":"哥斯达黎加"},
					    {"phoneNumber":"357","countryName":"CYPRUS","countryNameZh":"塞浦路斯"},
					    {"phoneNumber":"420","countryName":"CZECH REPUBLIC","countryNameZh":"捷克"},
					    {"phoneNumber":"45","countryName":"DENMARK","countryNameZh":"丹麦"},
					    {"phoneNumber":"253","countryName":"DJIBOUTI","countryNameZh":"吉布提"},
					    {"phoneNumber":"242","countryName":"DRC","countryNameZh":"刚果"},
					    {"phoneNumber":"593","countryName":"ECUADOR","countryNameZh":"厄瓜多尔"},
					    {"phoneNumber":"20","countryName":"EGYPT","countryNameZh":"埃及"},
					    {"phoneNumber":"503","countryName":"EL SALVADOR","countryNameZh":"萨尔瓦多"},
					    {"phoneNumber":"372","countryName":"ESTONIA","countryNameZh":"爱沙尼亚"},
					    {"phoneNumber":"268","countryName":"ESWATINI","countryNameZh":"埃斯瓦蒂尼"},
					    {"phoneNumber":"251","countryName":"ETH","countryNameZh":"埃塞俄比亚"},
					    {"phoneNumber":"679","countryName":"FIJI","countryNameZh":"斐济"},
					    {"phoneNumber":"358","countryName":"FINLAND","countryNameZh":"芬兰"},
					    {"phoneNumber":"33","countryName":"FRANCE","countryNameZh":"法国"},
					    {"phoneNumber":"594","countryName":"FRENCH GUIANA","countryNameZh":"法属圭亚那"},
					    {"phoneNumber":"689","countryName":"FRENCH POLYNESIA","countryNameZh":"法属波利尼西亚"},
					    {"phoneNumber":"241","countryName":"GABON","countryNameZh":"加蓬"},
					    {"phoneNumber":"220","countryName":"GAMBIA","countryNameZh":"冈比亚"},
					    {"phoneNumber":"995","countryName":"GEORGIA","countryNameZh":"格鲁吉亚"},
					    {"phoneNumber":"49","countryName":"GERMANY","countryNameZh":"德国"},
					    {"phoneNumber":"350","countryName":"GIBRALTAR","countryNameZh":"直布罗陀"},
					    {"phoneNumber":"30","countryName":"GREECE","countryNameZh":"希腊"},
					    {"phoneNumber":"1809","countryName":"GRENADA","countryNameZh":"格林纳达"},
					    {"phoneNumber":"1671","countryName":"GUAM","countryNameZh":"关岛"},
					    {"phoneNumber":"502","countryName":"GUATEMALA","countryNameZh":"瓜地马拉"},
					    {"phoneNumber":"224","countryName":"GUINEA","countryNameZh":"几内亚"},
					    {"phoneNumber":"592","countryName":"GUYANA","countryNameZh":"圭亚那"},
					    {"phoneNumber":"509","countryName":"HAITI","countryNameZh":"海地"},
					    {"phoneNumber":"504","countryName":"HONDURAS","countryNameZh":"洪都拉斯"},
					    {"phoneNumber":"852","countryName":"HONG KONG, CHINA","countryNameZh":"中国香港"},
					    {"phoneNumber":"36","countryName":"HUNGARY","countryNameZh":"匈牙利"},
					    {"phoneNumber":"354","countryName":"ICELAND","countryNameZh":"冰岛"},
					    {"phoneNumber":"91","countryName":"INDIA","countryNameZh":"印度"},
					    {"phoneNumber":"62","countryName":"INDONESIA","countryNameZh":"印度尼西亚"},
					    {"phoneNumber":"353","countryName":"IRELAND","countryNameZh":"爱尔兰"},
					    {"phoneNumber":"972","countryName":"ISRAEL","countryNameZh":"以色列"},
					    {"phoneNumber":"39","countryName":"ITALY","countryNameZh":"意大利"},
					    {"phoneNumber":"81","countryName":"JAPAN","countryNameZh":"日本"},
					    {"phoneNumber":"962","countryName":"JORDAN","countryNameZh":"约旦"},
					    {"phoneNumber":"327","countryName":"KAZAKHSTAN","countryNameZh":"哈萨克斯坦"},
					    {"phoneNumber":"254","countryName":"KENYA","countryNameZh":"肯尼亚"},
					    {"phoneNumber":"82","countryName":"KOREA, REPUBLIC OF","countryNameZh":"韩国"},
					    {"phoneNumber":"965","countryName":"KUWAIT","countryNameZh":"科威特"},
					    {"phoneNumber":"331","countryName":"KYRGYZSTAN","countryNameZh":"吉尔吉斯斯坦"},
					    {"phoneNumber":"856","countryName":"LAO PEOPLE'S DEMOCRATIC REPUBLIC","countryNameZh":"老挝人民民主共和国"},
					    {"phoneNumber":"371","countryName":"LATVIA","countryNameZh":"拉脱维亚"},
					    {"phoneNumber":"266","countryName":"LESOTHO","countryNameZh":"莱索托"},
					    {"phoneNumber":"231","countryName":"LIBERIA","countryNameZh":"利比里亚"},
					    {"phoneNumber":"423","countryName":"LIECHTENSTEIN","countryNameZh":"列支敦士登"},
					    {"phoneNumber":"370","countryName":"LITHUANIA","countryNameZh":"立陶宛"},
					    {"phoneNumber":"352","countryName":"LUXEMBOURG","countryNameZh":"卢森堡"},
					    {"phoneNumber":"853","countryName":"MACAO, CHINA","countryNameZh":"中国澳门"},
					    {"phoneNumber":"261","countryName":"MADAGASCAR","countryNameZh":"马达加斯加"},
					    {"phoneNumber":"265","countryName":"MALAWI","countryNameZh":"马拉维"},
					    {"phoneNumber":"60","countryName":"MALAYSIA","countryNameZh":"马来西亚"},
					    {"phoneNumber":"960","countryName":"MALDIVES","countryNameZh":"马尔代夫"},
					    {"phoneNumber":"356","countryName":"MALTA","countryNameZh":"马耳他"},
					    {"phoneNumber":"52","countryName":"MEXICO","countryNameZh":"墨西哥"},
					    {"phoneNumber":"373","countryName":"MOLDOVA","countryNameZh":"摩尔多瓦共和国"},
					    {"phoneNumber":"377","countryName":"MONACO","countryNameZh":"摩纳哥"},
					    {"phoneNumber":"1664","countryName":"MONTSERRAT","countryNameZh":"蒙特塞拉特"},
					    {"phoneNumber":"212","countryName":"MOROCCO","countryNameZh":"摩洛哥"},
					    {"phoneNumber":"258","countryName":"MOZAMBIQUE","countryNameZh":"莫桑比克"},
					    {"phoneNumber":"264","countryName":"NAMIBIA","countryNameZh":"纳米比亚"},
					    {"phoneNumber":"674","countryName":"NAURU","countryNameZh":"瑙鲁"},
					    {"phoneNumber":"977","countryName":"NEPAL","countryNameZh":"尼泊尔"},
					    {"phoneNumber":"31","countryName":"NETHERLANDS","countryNameZh":"荷兰"},
					    {"phoneNumber":"64","countryName":"NEW ZEALAND","countryNameZh":"新西兰"},
					    {"phoneNumber":"227","countryName":"NIGER","countryNameZh":"尼日尔"},
					    {"phoneNumber":"234","countryName":"NIGERIA","countryNameZh":"尼日利亚"},
					    {"phoneNumber":"47","countryName":"NORWAY","countryNameZh":"挪威"},
					    {"phoneNumber":"968","countryName":"OMAN","countryNameZh":"阿曼"},
					    {"phoneNumber":"92","countryName":"PAKISTAN","countryNameZh":"巴基斯坦"},
					    {"phoneNumber":"507","countryName":"PANAMA","countryNameZh":"巴拿马"},
					    {"phoneNumber":"675","countryName":"PAPUA NEW GUINEA","countryNameZh":"巴布亚新几内亚"},
					    {"phoneNumber":"595","countryName":"PARAGUAY","countryNameZh":"巴拉圭"},
					    {"phoneNumber":"51","countryName":"PERU","countryNameZh":"秘鲁"},
					    {"phoneNumber":"63","countryName":"PHILIPPINES","countryNameZh":"菲律宾"},
					    {"phoneNumber":"48","countryName":"POLAND","countryNameZh":"波兰"},
					    {"phoneNumber":"351","countryName":"PORTUGAL","countryNameZh":"葡萄牙"},
					    {"phoneNumber":"1787","countryName":"PUERTO RICO","countryNameZh":"波多黎各"},
					    {"phoneNumber":"974","countryName":"QATAR","countryNameZh":"卡塔尔"},
					    {"phoneNumber":"40","countryName":"ROMANIA","countryNameZh":"罗马尼亚"},
					    {"phoneNumber":"7","countryName":"RUSSIAN FEDERATION","countryNameZh":"俄罗斯联邦"},
					    {"phoneNumber":"250","countryName":"RWANDA","countryNameZh":"卢旺达"},
					    {"phoneNumber":"1758","countryName":"SAINT LUCIA","countryNameZh":"圣露西亚"},
					    {"phoneNumber":"1784","countryName":"SAINT VINCENT AND THE GRENADINES","countryNameZh":"圣文森特和格林纳丁斯"},
					    {"phoneNumber":"378","countryName":"SAN MARINO","countryNameZh":"圣马利诺"},
					    {"phoneNumber":"239","countryName":"SAO TOME AND PRINCIPE","countryNameZh":"圣多美和普林西比"},
					    {"phoneNumber":"966","countryName":"SAUDI ARABIA","countryNameZh":"沙特阿拉伯"},
					    {"phoneNumber":"221","countryName":"SENEGAL","countryNameZh":"塞内加尔"},
					    {"phoneNumber":"248","countryName":"SEYCHELLES","countryNameZh":"塞舌尔"},
					    {"phoneNumber":"232","countryName":"SIERRA LEONE","countryNameZh":"塞拉利昂"},
					    {"phoneNumber":"65","countryName":"SINGAPORE","countryNameZh":"新加坡"},
					    {"phoneNumber":"421","countryName":"SLOVAKIA","countryNameZh":"斯洛伐克"},
					    {"phoneNumber":"386","countryName":"SLOVENIA","countryNameZh":"斯洛文尼亚"},
					    {"phoneNumber":"677","countryName":"SOLOMON ISLANDS","countryNameZh":"所罗门群岛"},
					    {"phoneNumber":"27","countryName":"SOUTH AFRICA","countryNameZh":"南非"},
					    {"phoneNumber":"34","countryName":"SPAIN","countryNameZh":"西班牙"},
					    {"phoneNumber":"94","countryName":"SRILANKA","countryNameZh":"斯里兰卡"},
					    {"phoneNumber":"597","countryName":"SURINAME","countryNameZh":"苏里南"},
					    {"phoneNumber":"46","countryName":"SWEDEN","countryNameZh":"瑞典"},
					    {"phoneNumber":"41","countryName":"SWITZERLAND","countryNameZh":"瑞士"},
					    {"phoneNumber":"886","countryName":"TAIWAN, CHINA","countryNameZh":"中国台湾"},
					    {"phoneNumber":"992","countryName":"TAJIKISTAN","countryNameZh":"塔吉克斯坦"},
					    {"phoneNumber":"255","countryName":"TANZANIA","countryNameZh":"坦桑尼亚联合共和国"},
					    {"phoneNumber":"66","countryName":"THAILAND","countryNameZh":"泰国"},
					    {"phoneNumber":"228","countryName":"TOGO","countryNameZh":"多哥"},
					    {"phoneNumber":"676","countryName":"TONGA","countryNameZh":"汤加"},
					    {"phoneNumber":"788","countryName":"TUNISIA","countryNameZh":"突尼斯"},
					    {"phoneNumber":"90","countryName":"TURKEY","countryNameZh":"土耳其"},
					    {"phoneNumber":"993","countryName":"TURKMENISTAN","countryNameZh":"土库曼斯坦"},
					    {"phoneNumber":"380","countryName":"UKRAINE","countryNameZh":"乌克兰"},
					    {"phoneNumber":"971","countryName":"UNITED ARAB EMIRATES","countryNameZh":"阿拉伯联合酋长国"},
					    {"phoneNumber":"44","countryName":"UNITED KINGDOM","countryNameZh":"英国"},
					    {"phoneNumber":"1","countryName":"UNITED STATES","countryNameZh":"美国"},
					    {"phoneNumber":"598","countryName":"URUGUAY","countryNameZh":"乌拉圭"},
					    {"phoneNumber":"233","countryName":"UZBEKISTAN","countryNameZh":"乌兹别克斯坦"},
					    {"phoneNumber":"379","countryName":"VATICAN CITY","countryNameZh":"梵蒂冈"},
					    {"phoneNumber":"84","countryName":"VIETNAM","countryNameZh":"越南"},
					    {"phoneNumber":"260","countryName":"ZAMBIA","countryNameZh":"赞比亚"}
				],
        ruleInline: {
            firstName: [{
                required: true,
                message: 'Please fill in the name',
                trigger: 'blur'
            }],
						companyName: [{
						    required: true,
						    message: 'Please fill in the company name',
						    trigger: 'blur'
						}],
            phone: [{
                required: true,
                message: 'Please fill in the phone',
                trigger: 'blur'
            }],
						country: [{
						    required: true,
						    message: 'Please fill in the country',
						    trigger: 'blur'
						}],
						jobTitle: [{
						    required: true,
						    message: 'Please fill in the job title',
						    trigger: 'blur'
						}],
						employees: [{
						    required: true,
						    message: 'Please fill in the employees',
						    trigger: 'blur'
						}],
						industry: [{
						    required: true,
						    message: 'Please fill in the industry',
						    trigger: 'blur'
						}],
            message: [{
                required: true,
                message: 'Please fill in the message',
                trigger: 'blur'
            }],
            email: [{
                required: true,
                message: 'Please fill in the email',
                trigger: 'blur'
            },{
                type: 'email',
                message: 'Email format is error',
                trigger: 'blur'
            }]
        },
				isFollowing: false, // 控制左侧是否跟随滚动的状态
				      scrollHandler: null // 用于存储滚动事件处理函数的引用
    }
  },
  methods:{
      submit(name){
            this.$refs[name].validate((valid) => {
                if (valid) {
									this.loading = true
									let params = {
										firstName:this.form.firstName,
										companyName:this.form.companyName,
										country:this.form.country,
										email:this.form.email,
										phone:"+"+this.form.areaCode+" "+this.form.phone,
										jobTitle:this.form.jobTitle,
										employees:this.form.employees,
										industry:this.form.industry,
										webLink:this.form.webLink,
										message:this.form.message,
									}
                    apiUrl.customer(params).then(res => {
                        this.form.firstName = ''
                        this.form.companyName = ''
                        this.form.country = ''
                        this.form.email = ''
                        this.form.areaCode = '86'
                        this.form.phone = ''
                        this.form.jobTitle = ''
                        this.form.employees = ''
                        this.form.industry = ''
                        this.form.webLink = ''
												this.form.message = ''
                        Notice.success({
                            title: 'Success',
                        })
												this.loading= false
                    })
                } else{
									Notice.warning({
									    title: 'Please provide complete information!',
									})
								}
            })

      },
			 /**
			     * 计算触发左侧跟随滚动的阈值
			     */
			    getScrollThreshold() {
			      const sidebar = this.$refs.leftSidebar;
			      if (!sidebar) return 0;
			      // 左侧高度 - 视口高度 = 触发跟随滚动的阈值
			      const sidebarHeight = sidebar.offsetHeight;
			      const viewportHeight = window.innerHeight;
			      return 1800 - viewportHeight;
			    },
			    
			    /**
			     * 滚动事件处理函数
			     */
			    handleScroll() {
			      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			      const threshold = this.getScrollThreshold();
			      
			      // 根据滚动距离和阈值判断是否需要跟随滚动
			      this.isFollowing = scrollTop >= threshold;
			    }
  },
	mounted() {
		  // 绑定滚动事件处理函数，使用箭头函数确保this指向正确
		     this.scrollHandler = () => this.handleScroll();
		     window.addEventListener('scroll', this.scrollHandler);
		     window.addEventListener('resize', this.scrollHandler);
		     
		     // 初始加载时执行一次，确保状态正确
		     this.handleScroll();
						
	},
	beforeDestroy() {
	    // 组件销毁前移除事件监听，防止内存泄漏
	    window.removeEventListener('scroll', this.scrollHandler);
	    window.removeEventListener('resize', this.scrollHandler);
	  },
  components:{
      Header,Footer
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media all and (min-width:960px){
	.page-container{
		display: flex;
		position: relative;
		// position: absolute;
	}
	.left-sidebar{
		// flex: 1;
		padding-left: 180px;
		width: 50%;
		 height: 780px; /* 假设左侧内容高度（实际由内容决定） */
		   /* 初始固定定位 */
		       position: fixed;
		       top: 0;
		       left: 0;
					 // position: absolute; /* 改为基于.page-container的绝对定位 */
					 // top: auto; /* 取消顶部固定 */
					 // bottom: 0; /* 固定在父容器底部，随父容器滚动 */
		   
	}
	.left-sidebar.follow-scroll {
	      position: absolute; /* 改为基于.page-container的绝对定位 */
	      top: auto; /* 取消顶部固定 */
	      bottom: 0; /* 固定在父容器底部，随父容器滚动 */
	    }
	.contentLeft_row{
		margin-left: 150px;
	}
	.contentRight{
		// flex: 1;
		    width: 50%;
				margin-left: 50%;
				height: 1800px; 
	}
    .contact{
        position: relative;
        width: 100%;
        .banner{
            background: linear-gradient(to right, #1E4A80, #0A2447);
						background-color: #001B37;
            background-size: 100% ;
            width: 100%;
            padding-top: 60px;
						padding-bottom: 130px;
						.contactText{
							margin-top: 120px;
							font-weight: 600;
							font-size: 20px;
							color: #00D1B7;
							line-height: 30px;
							// margin-left: 150px;
						}
            .title{
               font-family: Montserrat, Montserrat;
               font-weight: bold;
               font-size: 38px;
               color: #FFFFFF;
               line-height: 60px;
                text-align: left ;
								// height:1800px;
								// margin-left: 150px;
            }
            .title1{
                font-size: 20px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 36px;
                margin-top: 34px;
                text-align: left;
								// margin-left: 150px;
								.title1_row{
									display: flex;
									font-family: OpenSans, OpenSans;
									font-weight: 400;
									font-size: 16px;
									color: #FFFFFF;
									line-height: 24px;
									margin-bottom: 10px;
									// opacity: 0.8;
									img{
										margin-top: 2px;
										margin-right: 8px;
									}
									.title1_text{
										opacity: 0.8;
									}
								}
								.title1_email{
									display: flex;
									font-family: OpenSansRoman, OpenSansRoman;
									font-weight: bold;
									font-size: 20px;
									color: #FFFFFF;
									line-height: 20px;
									text-align: left;
									font-style: normal;
									text-decoration-line: underline;
									img{
										margin-top: 1px;
										margin-right: 8px;
									}
								}
            }
            .form{
                width:600px;
								// max-height:930px;
								// overflow-y: auto;
                background: #FFFFFF;
                box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                // margin: 0 auto;
                margin-top: 54px;
                // margin-bottom: 130px;
                padding: 52px;
								.form_text{
									font-family: OpenSansRoman, OpenSansRoman;
									font-weight: bold;
									font-size: 20px;
									color: #001B37;
									line-height: 30px;
									text-align: justify;
									font-style: normal;
									margin-bottom: 20px;
								}
                .input{
                    // width:496px;
                }
                .mr_30{
                    margin-right: 30px;
                }
                .mt_32{
                    margin-top: 32px;
                }
                .infoText{
                    font-family: OpenSans, OpenSans;
                    font-weight: 400;
                    font-size: 14px;
                    color: #5A7184;
                    line-height: 20px;
                    text-align: justify;
                    font-style: normal;
                }
                .form_tiem{
                    // display: inline-block;
                }
            }
        }
    }
}
@media all and (max-width:960px){
	.page-container{
	}
	.left-sidebar{
	}
	.contentRight{
	}
	
	.contactText{
		margin-top: 140px;
		font-weight: 600;
		font-size: 20px;
		color: #00D1B7;
		line-height: 30px;
		margin: 0 25px;
		text-align: center;
	}
    .contact{
        position: relative;
        width: 100%;
        .banner{
					 background: linear-gradient(to right, #1E4A80, #0A2447);
            // background: url('../../assets/contactBackground.png') no-repeat;
            background-position-x: center;
            background-size:500%;
            width: 100%;
            padding-top: 100px;
						padding-bottom: 50px;
            .title{
                font-size: 32px;
                font-family: OpenSans-SemiBold, OpenSans;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 40px;
                margin: 0 25px;
                text-align: center;
            }
            .title1{
                font-size: 15px;
                font-family: OpenSans-Regular, OpenSans;
                font-weight: 400;
                color: #FAFAFB;
                line-height: 28px;
                margin: 0 35px;
                margin-top: 20px;
                // text-align: center;
								.title1_row{
									display: flex;
									font-family: OpenSans, OpenSans;
									font-weight: 400;
									font-size: 16px;
									color: #FFFFFF;
									line-height: 24px;
									margin-bottom: 10px;
									// opacity: 0.8;
									img{
										margin-top: 2px;
										margin-right: 8px;
									}
									.title1_text{
										opacity: 0.8;
									}
								}
								.title1_email{
									display: flex;
									font-family: OpenSansRoman, OpenSansRoman;
									font-weight: bold;
									font-size: 20px;
									color: #FFFFFF;
									line-height: 20px;
									text-align: left;
									font-style: normal;
									text-decoration-line: underline;
									img{
										margin-top: 1px;
										margin-right: 8px;
									}
								}
            }
            .form{
                margin: 0 18px;
                background: #FFFFFF;
                box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                margin-top: 20px;
                // margin-bottom: 50px;
                padding: 25px 20px;
								.form_text{
									font-family: OpenSansRoman, OpenSansRoman;
									font-weight: bold;
									font-size: 20px;
									color: #001B37;
									line-height: 30px;
									text-align: justify;
									font-style: normal;
									margin-bottom: 20px;
								}
                .input{
                    width:100%;
                }
                .mr_30{
                    margin-right: 0px;
                }
                .mt_32{
                    margin-top: 0px;
                }
                .infoText{
                    font-size: 12px;
                    font-family: OpenSans-Regular, OpenSans;
                    font-weight: 400;
                    color: #5A7184;
                    line-height: 20px;
                }
                .form_tiem{
                    display: block;
                }
            }
        }
    }
}
</style>
<style lang="less">
	*::-webkit-scrollbar,.layout-content::-webkit-scrollbar {
	    width: 0px;    
	    height: 10px;
	}
	*::-webkit-scrollbar-thumb,.layout-content::-webkit-scrollbar-thumb {
	    border-radius: 20px;
	    -webkit-box-shadow: inset 0 0 5px rgb(180,180,180);
	    background: rgb(180,180,180);
	}
	*::-webkit-scrollbar-track,.layout-content::-webkit-scrollbar-track {
	    -webkit-box-shadow: inset 0 0 5px rgb(220,220,220);
	    border-radius: 0;
	    background: rgb(220,220,220);
	}
	.selectRow{
		.ivu-select-single .ivu-select-selection{
			height: 56px !important;
			background: #FFFFFF !important;
			border-radius: 8px !important;
			border: 1px solid #C3CAD9 !important;
			font-size: 16px !important;
		}
		.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
			height: 56px !important;
			font-size: 16px !important;
			line-height: 56px !important;
			margin-left: 7px !important;
		}
	}
	.contact{
		.ivu-select .ivu-select-dropdown{
			padding: none !important;
			
		}
		.ivu-select-dropdown{
			padding: none !important;
		}
		.ivu-select-item{
			padding: none !important;
			height: 40px !important;
			font-size: 16px !important;
			text-align: left !important;;
			line-height: 26px !important;
		}
		.ivu-select-item-selected, .ivu-select-item-selected:hover{
			color:#515a6e !important;
			
		}
		.ivu-select-single .ivu-select-selection .ivu-select-selected-value{
			margin-left: 6px !important;
		}
	}
	

@media all and (min-width:960px){
	.numberSelect{
		width: 180px !important;
	}
	.outCompanyName{
		display: none !important;
	}
	.inCompanyName{
		width: 100px !important;
	}
	.contact .ivu-select .ivu-select-dropdown{
		width:182px !important;
		// overflow: hidden !important;
		// text-overflow: ellipsis !important;  /* 显示省略号 */
		// white-space: nowrap !important;  /* 禁止换行 */
	}
	 .contact .ivu-select-dropdown{
		// max-height:296px !important;
	}
	
	.ivu-input-group-append, .ivu-input-group-prepend{
		background-color:#fff !important;
		border: 1px solid #C3CAD9 !important;
		border-radius: 8px 0 0 8px !important;
	}
	.ivu-select-single .ivu-select-selection .ivu-select-selected-value{
		font-size: 16px !important;
		text-align: left !important;
		margin-right: 50px !important;
	}

    .ivu-input{
        height: 56px !important;
        background: #FFFFFF !important;
        border-radius: 8px !important;
        border: 1px solid #C3CAD9 !important;
        font-size: 16px !important;
        padding-left: 18px !important;
    }
		
		.select_input .ivu-input{
		    height: 56px !important;
		    background: #FFFFFF !important;
		    border-radius: 0 8px 8px 0 !important;
		    border: 1px solid #C3CAD9 !important;
		    font-size: 16px !important;
		    padding-left: 18px !important;
		}
    textarea.ivu-input{
        height: 150px !important;
        background: #FFFFFF !important;
        padding: 18px !important;

    }
    .ivu-form .ivu-form-item-label{
        font-size: 16px !important;
        font-family: OpenSans-SemiBold, OpenSans !important;
        font-weight: 600 !important;
        color: #5A7184 !important;
        line-height: 22px !important;
    }
    .ivu-btn{
        width: 155px !important;
        height: 48px !important;
        background: #1565D8 !important;
        border-radius: 8px !important;
        font-size: 16px !important;
        font-family: OpenSans-Bold, OpenSans !important;
        font-weight: bold !important;
        color: #FFFFFF !important;
        line-height: 22px !important;
    }
    .ivu-form-item-required .ivu-form-item-label:before{
        display: none !important;
    }
}

@media all and (max-width:960px){
	.numberSelect{
		width: 100px !important;
	}
	.contact .ivu-select .ivu-select-dropdown{
		width:300px !important;
		// overflow: hidden !important;
		// text-overflow: ellipsis !important;  /* 显示省略号 */
		// white-space: nowrap !important;  /* 禁止换行 */
	}
	.outCompanyName{
		width:260px !important;
	}
	.itemTooltip{
		display: none !important;
	}
	.ivu-select .ivu-select-dropdown{
		padding: none !important;
	}
	.ivu-select-dropdown{
		padding: none !important;
	}
	.ivu-input-group-append, .ivu-input-group-prepend{
		background-color:#fff !important;
		border: 1px solid #C3CAD9 !important;
		border-radius: 8px 0 0 8px !important;
	}
    .ivu-input{
        height: 40px !important;
        background: #FFFFFF !important;
        border-radius: 8px !important;
        border: 1px solid #C3CAD9 !important;
        font-size: 14px !important;
        padding-left: 16px !important;
    }
		.select_input .ivu-input{
			 border-radius: 0 8px 8px 0 !important;
        // height: 40px !important;
        // background: #FFFFFF !important;
        // border-radius: 0px !important;
        // border: 1px solid #C3CAD9 !important;
        // font-size: 14px !important;
        // padding-left: 16px !important;
    }
    textarea .ivu-input{
        height: 157px !important;
        background: #FFFFFF !important;
        padding: 16px !important;

    }
    .ivu-form .ivu-form-item-label{
        font-size: 14px !important;
        font-family: OpenSans-SemiBold, OpenSans !important;
        font-weight: 600 !important;
        color: #5A7184 !important;
        line-height: 20px !important;
    }
		.btnRow{
			display: flex;
			justify-content: center;
		}
    .btnRow .ivu-btn{
        width: 130px !important;
        height: 48px !important;
        background: #1565D8 !important;
        border-radius: 8px !important;
        font-size: 15px !important;
        font-family: OpenSans-Bold, OpenSans !important;
        font-weight: bold !important;
        color: #FFFFFF !important;
        line-height: 20px !important;
    }
    .ivu-form-item-required .ivu-form-item-label:before{
        display: none !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/page/home_v2.0/contact.vue